import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SwitchChangeEvent, SwitchComponent } from '@cf/shared/forms/primitives';
import { TimezoneSelectComponent } from '@cf/shared/forms/timezone-select';
import type { TimezoneEnum } from '@cf/temp/services';
import { NgxTolgeeModule } from '@tolgee/ngx';
@Component({
  selector: 'cf-time-settings',
  imports: [FormsModule, TimezoneSelectComponent, NgxTolgeeModule, SwitchComponent],
  templateUrl: './time-settings.component.html',
  styleUrl: './time-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSettingsComponent {
  @Input() disabled = false;

  @Input() timezone!: TimezoneEnum;

  @Input() appendTo = 'body';

  @Input() time_format!: number;

  @Input() date!: string;

  @Output() formatChange: EventEmitter<SwitchChangeEvent> = new EventEmitter();

  @Output() timezoneChange: EventEmitter<TimezoneEnum> = new EventEmitter<TimezoneEnum>();

  get timeFormat(): boolean {
    return this.time_format !== 12;
  }
}
